import { select } from '@ps/web-core-store';
import type React from 'react';
import { useSelector } from 'react-redux';

import GamesList from './GamesList';
import NoGamesAvailable from './NoGamesAvailable';

const ActiveGames: React.FC<{
  handleClose?: () => void;
}> = ({ handleClose }) => {
  const games = useSelector(select.activeGames.getGames);

  return games.length ? <GamesList games={games} onAction={handleClose} /> : <NoGamesAvailable />;
};

export default ActiveGames;
